import { api } from '@/services/api';
import { useTenants } from '@/services/tenants/useTenants';
import { useQuery } from '@tanstack/react-query';

export const PART_IMAGE_LABEL_CROP_QUERY_KEY = 'partImageIdentification.labelCrop';

const ONE_HOUR_MS = 60 * 60 * 1000;

export const useGetPartImageLabelCrop = (identificationId: string, index: number) => {
  const { getTenantId } = useTenants();
  const tenantId = getTenantId();
  const { data: image, error } = useQuery({
    queryKey: [PART_IMAGE_LABEL_CROP_QUERY_KEY, { identificationId, index }],
    queryFn: async () => {
      const { data } = await api.http.request<Blob>({
        path: `/tenants/${tenantId}/part-finder/image-identifications/${identificationId}/labels/${index}.jpg`,
        method: 'GET',
        secure: true,
        format: 'blob',
      });
      return URL.createObjectURL(new Blob([data], { type: 'image/jpeg' }));
    },
    enabled: !!identificationId && !!tenantId,
    retry: false,
    staleTime: ONE_HOUR_MS,
    gcTime: ONE_HOUR_MS,
  });
  return { image, error };
};
